// extracted by mini-css-extract-plugin
module.exports = {"changeDisclaimer":"cz","cltLink":"dz","shippingDisclaimer":"ez"};